export enum ArtUploadStep {
  SELECT_ASSET = "SELECT_ASSET",
  EDIT_MEDIA_ASSET = "EDIT_IMAGE_ASSET",
  EDIT_NAMEPLATE_ASSET = "EDIT_TEXT_ASSET",
}
